import { ModuleContent } from '@src/components/Editor/types'

import theme from '@src/styled/theme'

const citations = {
  type: 'CITATIONS',
  color: theme.colors.cheggOrange,
  id: 1,
}

const grammar = {
  type: 'GRAMMAR',
  color: theme.colors.sky,
  id: 2,
}

const punctuation = {
  type: 'PUNCTUATION',
  color: theme.colors.sky,
  id: 3,
}

const spelling = {
  type: 'SPELLING',
  color: theme.colors.sky,
  id: 4,
}

const style = {
  type: 'STYLE',
  color: theme.colors.sky,
  id: 5,
}

const modules = {
  default: [citations, grammar, punctuation, spelling, style],
}

export const initialState: ModuleState = modules.default

export type ModuleState = ModuleContent[]

const modulesReducer = (state: ModuleState = initialState, action: any) => {
  return state
}

export default modulesReducer



// WEBPACK FOOTER //
// ./src/state/modules/reducer.ts